module.exports = require("d3-array");